import {useQuery} from 'admin/lib/apollo'
import {GET_GROUPS} from 'admin/gql/Groups.gql'
import {StringParam, useQueryParams, withDefault} from 'use-query-params'
import useDestroyable from './useDestroyable'

export default organisationId => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, '')
  })

  const {data: {groups = []} = {}} = useQuery(GET_GROUPS, {
    variables: {organisationId, ...filters}
  })

  const {destroy, errors} = useDestroyable('Group')

  return {
    filters,
    setFilters,
    groups,
    destroy,
    errors
  }
}
